import "./App.css";

import HomePage from "./views/HomePage";
import Detail from "./views/DetailPage";
import { Route, Routes } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage></HomePage>} />
        <Route path="/detail/:id" element={<Detail></Detail>} />
      </Routes>
    </div>
  );
}

export default App;
